<template>
  <div>
    <span v-if="locationBeaconOnWithNoArea">{{ displayLocationName }}</span>
    <span v-else>{{ params.locationName }}</span>
    <v-dialog @click:outside="closeModalVideo" scrollable v-model="dialog">
      <v-card>
        <v-card-title class="secondary">{{ params.name }}</v-card-title>
        <v-card-text>
          <video
            class="video-player mt-5"
            ref="video"
            autoplay
            controls
            height="700"
          >
            <source
              src="http://mediaupload-us-east1.s3.amazonaws.com/videos/Adding_Locations_720p.mp4"
              type="video/mp4"
            />
          </video>
          <v-row>
            <v-col>
              <v-btn
                @click="closeModalVideo"
                depressed
                color="secondary float-right"
              >{{ $t('close') }}</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      menuShown: false,
      hideAlertForMacAddress: 'c0:00'
    };
  },
  props: ['params', 'field'],
  openModal() {
    this.dialog = true;
  },
  computed: {
    lbMacAddress() {
      return this.params.location.macAddress.toUpperCase();
    },
    tagMacAddress() {
      return this.params.macAddress.toUpperCase();
    },
    displayLocationName() {
      return this.params.locationName;
    },
    locationBeaconOnWithNoArea() {
      let isIndoor = false;
      if (this.params.locationTime && !this.params.latitudeTime) {
        isIndoor = true;
      } else if (this.params.locationTime && this.params.latitudeTime) {
        const locationTime = this.$moment(this.params.locationTime);
        const latitudeTime = this.$moment(this.params.latitudeTime);
        const eventTimeDiff = locationTime.diff(latitudeTime, 'seconds');
        isIndoor = eventTimeDiff > 0; //Last event by LB
      }
      let macAddressFirstFiveDigits = '';
      if (this.params.location.macAddress) {
        macAddressFirstFiveDigits = this.params.location.macAddress.slice(0,5).toLowerCase();
      }
      return (
        this.params.location &&
        this.params.location.macAddress &&
        macAddressFirstFiveDigits !== this.hideAlertForMacAddress &&
        this.params.area &&
        !this.params.area.id &&
        isIndoor
      );
    }
  },
  methods: {
    closeModalVideo() {
      this.$refs.video.pause();
      this.dialog = false;
    },
    submitTicket() {
      window.open(
        'https://link-labs.zendesk.com/hc/en-us/requests/new?ticket_form_id=360000334931',
        '_blank'
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.warningIcon {
  color: var(--v-info-lighten1);
  height: 20px;
  width: 20px;
}
</style>